import React from "react";
import { FaTshirt, FaIndustry, FaHotel, FaUserMd, FaLeaf } from "react-icons/fa";

const SEOContent = () => {
  const steps = [
    {
      icon: FaTshirt,
      title: "Trusted Apparel Manufacturer for Corporate & Industrial Clothing",
      desc: "We specialize in custom corporate uniforms, branded t-shirts, promotional wear, and durable industrial workwear with quality assurance."
    },
    {
      icon: FaTshirt,
      title: "Custom Corporate Uniforms & Branded Clothing Suppliers in India",
      desc: "Providing premium corporate uniforms, office wear, and branded polo t-shirts designed for style and comfort."
    },
    {
      icon: FaIndustry,
      title: "Industrial Workwear Suppliers & Safety Uniforms Manufacturer",
      desc: "Supplying heavy-duty construction worker uniforms, industrial safety wear, and durable protective clothing."
    },
    {
      icon: FaHotel,
      title: "Hospitality Uniforms & Hotel Staff Apparel in Chennai",
      desc: "We manufacture hotel staff uniforms, restaurant chef coats, aprons, and hospitality wear for the service industry."
    },
    {
      icon: FaUserMd,
      title: "Healthcare Uniforms, Hospital Scrubs & School Uniforms",
      desc: "Bulk supplier of hospital scrubs, lab coats, and school uniforms in Tiruppur and across India."
    },
    {
      icon: FaLeaf,
      title: "Cotton Polo T-Shirts, Dri-Fit Fabrics & Eco-Friendly Uniforms",
      desc: "Offering breathable fabrics, customized embroidered uniforms, and eco-friendly corporate wear for modern businesses."
    },
    {
      icon: FaIndustry,
      title: "Tiruppur Garment Exporter & OEM Clothing Manufacturer", 
      desc: "We handle bulk corporate t-shirt orders, wholesale workwear supply, private label clothing manufacturing, and OEM apparel solutions."
    },
    {
      icon: FaTshirt,
      title: "Get Custom Logo Uniforms & Promotional T-Shirts in Bulk",
      desc: "Partner with Dheeram Apparel Creations for bulk corporate uniforms and customized promotional apparel in Chennai & Tiruppur."
    }
  ];

  return (
    <section className="bg-[#F6AE1B] py-16 px-6 md:px-12 lg:px-20">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl md:text-5xl font-extrabold text-center text-gray-900 mb-12">
          Our <span className="text-white">Expertise Timeline</span>
        </h1>

        <div className="relative border-l-4 border-[#000000] pl-6 space-y-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative">
                {/* Icon badge */}
                <span className="absolute -left-10 flex items-center justify-center w-12 h-12 
                                 rounded-full bg-white text-black shadow-lg">
                  <Icon className="text-2xl" />
                </span>

                <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-xl transition-shadow">
                  <h2 className="text-lg md:text-xl font-semibold text-gray-800 mb-2">
                    {step.title}
                  </h2>
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SEOContent;
